<template>
  <div class="analytics analyst-analytics mb-3">
    <filter-bar
      :timeframe="timeframe"
      @change="setTimeframe"
    />

    <stats
      :data="basicMetrics"
      :props="basicMetricProps"
      :min-width="minWidth"
    >
    </stats>



    <grouped-line-chart
      v-if="dimensions"
      :items="readership"
      :item-groups="lineChartGroups"
      :timeframe-labels="timeframeLabels"
      :width="dimensions.width"
      :client-width="clientWidth"
      :min-width="minWidth"
      :height="400"
      :timeframe="timeframe"
      :type="analyticsType"
    />

    <multiple-ranking-lists
      :settings="topListTypes"
      :ranking-lists="topLists"
      :client-width="clientWidth"
      :data="data"
    />
  </div>
</template>

<script>
import {constructReadershipGrouped} from '@/analytics/data-analyser'

import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import TimeframeMixin from '@/analytics/mixins/TimeframeMixin'

import FilterBar from '@/components/FilterBar'
import Stats from '@/components/Stats'
import GroupedLineChart from './GroupedLineChart.vue'
// import GroupedLineChart from '@/components/d3/GroupedLineChart.vue'

export default {
  components: {
    FilterBar,
    Stats,
    GroupedLineChart,
  },
  mixins: [AnalyticsMixin, TimeframeMixin],
  async mounted() {
    const response = await this.loadData(
      `analyst/${this.data.id}`,
      undefined,
      this.$login.channelScopeId()
    )

    console.log('hi')
  },
  data () {
    return {
      analyticsType: 'analyst',
      basicMetricProps: ['emailOpens', 'emailClicks',  'webViews'],
      lineChartGroups: ['webViews'],
      topListTypes: {

        analystArticle: {title: 'Popular Articles', path: 'articles', colWidth: 8, activeEnabled: false, cols: ['name',  'engagement'], type: 'infinity-rank'},
        analystUser: {title: 'Top Readers', path: 'users', colWidth: 4, activeEnabled: false, cols: null, type: 'infinity-rank'},
        // channelAnalyst: {title: 'Channel League Table', path: 'analysts', colWidth: 4, activeEnabled: true, cols: null},
        // networkAnalyst: {title: 'Network League Table', path: 'analysts', colWidth: 4, activeEnabled: true, cols: null},
        // analystAccount: {title: 'Top Accounts', path: 'accounts', colWidth: 4, activeEnabled: false, cols: null, type: 'infinity-rank'},
      },
    }
  },
  computed: {
    timeframeLabels() {
      if (!this.cogData) {
        return []
      }

      return this.cogData.series[this.timeframe].webViewsDaily.map((item) => item.date)
    },

    items() {
      const items = this.cogData
      if (!items) {
        return {
          webViews: []
        }
      }

      console.log('ohno', items)
console.log(items.series[this.timeframe].webViewsDaily,'hi')
      return { webViews: items.series[this.timeframe].webViewsDaily.map((d) => d.value) }
    },

    lineChartSources () {
      return { web: ['article_views']}
    },
    // impactScore() {
    //   const items = this.hello.find(x => x.key === this.timeframe) || this.hello.find(x => x.key === 'this_90_days')
    //   return (items?.impactScore || 0).toLocaleString() || 0
    // }
  },
  watch: {
    timeframe: function (timeframe, oldData) {
      // this.loadData(timeframe)
      if (this.cogData) {

            this.readership = [
      {
        key: 'webViews',
        name: 'Web Views',
        val: {
          article: this.cogData.series[this.timeframe].webViewsDaily.map((x) => x.value),
          // channel: this.cogData.webViewAveragesChart.map(
          //   (x) => x.channelAverage
          // ),
          // network: this.cogData.webViewAveragesChart.map(
          //   (x) => x.networkAverage
          // ),
        },
      },
      // {
      //   key: 'emailOpens',
      //   name: 'Email Opens',
      //   val: {
      //     article: this.cogData.series.emailOpensDaily.map((x) => x.value),
      //     // channel: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.channelAverage
      //     // ),
      //     // network: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.networkAverage
      //     // ),
      //   },
      // },
      // {
      //   key: 'emailClicks',
      //   name: 'Email Clicks',
      //   val: {
      //     article: this.cogData.series.clicksDaily.map((x) => x.value),
      //     // channel: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.channelAverage
      //     // ),
      //     // network: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.networkAverage
      //     // ),
      //   },
      // },
    ]
    console.log('readership',this.readership)
        // this.readership = constructReadershipGrouped(newData['readership'], this.lineChartSources, this.analyticsType, ['channel', 'network'])
        this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
    this.topLists = {
      analystUser: this.cogData.topReadersByTimeframe[this.timeframe].map(tr => ({
          id: tr.userId,
          name: tr.user?.name,
          value: tr.webViews,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        })),
      analystArticle: this.cogData.topArticlesByTimeframe[this.timeframe].map(tr => ({
          id: tr.articleId,
          name: tr.article ? tr.article.title : '-',
          value: tr.views,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        }))
    }
      }
    },

    cogData() {
      this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
                  this.readership = [
      {
        key: 'webViews',
        name: 'Web Views',
        val: {
          article: this.cogData.series[this.timeframe].webViewsDaily.map((x) => x.value),
          // channel: this.cogData.webViewAveragesChart.map(
          //   (x) => x.channelAverage
          // ),
          // network: this.cogData.webViewAveragesChart.map(
          //   (x) => x.networkAverage
          // ),
        },
      },
      // {
      //   key: 'emailOpens',
      //   name: 'Email Opens',
      //   val: {
      //     article: this.cogData.series.emailOpensDaily.map((x) => x.value),
      //     // channel: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.channelAverage
      //     // ),
      //     // network: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.networkAverage
      //     // ),
      //   },
      // },
      // {
      //   key: 'emailClicks',
      //   name: 'Email Clicks',
      //   val: {
      //     article: this.cogData.series.clicksDaily.map((x) => x.value),
      //     // channel: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.channelAverage
      //     // ),
      //     // network: this.cogData.emailOpenAveragesChart.map(
      //     //   (x) => x.networkAverage
      //     // ),
      //   },
      // },
    ]

    this.topLists = {
      analystUser: this.cogData.topReadersByTimeframe[this.timeframe].map(tr => ({
          id: tr.userId,
          name: tr.user?.name,
          value: tr.webViews,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        })),
      analystArticle: this.cogData.topArticlesByTimeframe[this.timeframe].map(tr => ({
          id: tr.articleId,
          name: tr.article ? tr.article.title : '-',
          value: tr.views,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        })),

    }
    },
  },
  methods: {
    async fetchStreamAnalyses () {
      this.keenAnalyses = await this.$keen.fetchStreamAnalyses(this.analyticsType, this.sources, this.timeframe, this.data.id, this.data.channel_id)
    },
  },
}
</script>
